module.exports = __webpack_public_path__ + "images/places/asm_74-b27f73d4b38689129f8866387b623e13.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/asm_74.jpg
 ** module id = 313
 ** module chunks = 0
 **/